import { ConfigCaracterizacao } from "../interfaces";

/** Municípios com integração tributária de pessoas (atualizar e sincronizar). */
export const MUNICIPIOS_INTEGRACAO_PESSOA = [
  "maracanau",
  "vitoriadaconquista",
  "riobranco",
  "mariana",
  "horizonte",
] as const;

export function usaIntegracaoPessoa(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_INTEGRACAO_PESSOA);
}

/** Municípios que abrem o diálogo de sincronização de pessoa (busca por código). */
export const MUNICIPIOS_DIALOG_SINCRONIZA_PESSOA = [
  "vitoriadaconquista",
  "riobranco",
  "mariana",
] as const;

/** Municípios que atualizam pessoa via id do imobiliário (em vez de id_pessoa). */
export const MUNICIPIOS_ATUALIZA_PESSOA_POR_IMOBILIARIO = [
  "vitoriadaconquista",
  "riobranco",
] as const;

export function atualizaPessoaPorImobiliario(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_ATUALIZA_PESSOA_POR_IMOBILIARIO);
}

/** Municípios que exibem aviso de débitos na troca de titularidade. */
export const MUNICIPIOS_AVISO_DEBITOS_TITULARIDADE = ["mariana"] as const;

export function usaAvisoDebitosTitularidade(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_AVISO_DEBITOS_TITULARIDADE);
}

/** Municípios com sincronização de lote/imobiliário via socket. */
export const MUNICIPIOS_INTEGRACAO_SYNC = [
  "maracanau",
  "vitoriadaconquista",
  "riobranco",
] as const;

export function usaIntegracaoSync(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_INTEGRACAO_SYNC);
}

export function isMunicipio(
  municipio: string | undefined | null,
  lista: readonly string[]
): boolean {
  const key = municipio?.toLowerCase();
  return !!key && (lista as readonly string[]).includes(key);
}

export function usaDialogSincronizaPessoa(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_DIALOG_SINCRONIZA_PESSOA);
}

/** Municípios que não exibem os botões de vincular/desvincular pessoa manualmente. */
export const MUNICIPIOS_OCULTA_VINCULO_MANUAL_PESSOA = [
  "riobranco",
] as const;

export function ocultaBotoesVinculoManualPessoa(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_OCULTA_VINCULO_MANUAL_PESSOA);
}

/** Fallback quando `edificacoesHierarquicasPorTipoVinculo` ainda não está no tenantConfig. */
export const MUNICIPIOS_EDIFICACOES_HIERARQUICAS = ["riobranco"] as const;

/** Municípios que suportam a funcionalidade de desmembrar imóveis (DialogSplitImobiliario). */
export const MUNICIPIOS_USA_SPLIT_IMOBILIARIO = [
  "maracanau",
  "vitoriadaconquista",
  "mariana",
  "horizonte",
] as const;

export function usaSplitImobiliario(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_SPLIT_IMOBILIARIO);
}

/** Municípios em que o número da nova unidade é calculado pelo servidor (espelha `DESMEMBRAR_UNIDADE_NUMERACAO_AUTOMATICA` no api-cadastro). */
export const MUNICIPIOS_NUMERACAO_AUTOMATICA_UNIDADE = ["horizonte"] as const;

export function usaNumeracaoAutomaticaUnidade(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_NUMERACAO_AUTOMATICA_UNIDADE);
}

/** Municípios que suportam a funcionalidade de juntar imóveis (DialogJoin). */
export const MUNICIPIOS_USA_JOIN_IMOBILIARIO = [
  "maracanau",
  "vitoriadaconquista",
  "riobranco",
  "mariana",
  "horizonte",
] as const;

export function usaJoinImobiliario(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_JOIN_IMOBILIARIO);
}

/** Municípios que usam a rota de situação do IPTU (`situacao-iptu`). */
export const MUNICIPIOS_USA_SITUACAO_IPTU = ["maracanau", "horizonte"] as const;

export function usaSituacaoIptu(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_USA_SITUACAO_IPTU);
}

/** Municípios cujo desmembramento exige campos extras (telheiro/galpão). */
export const MUNICIPIOS_SPLIT_TELHEIRO_GALPAO = ["vitoriadaconquista"] as const;

export function usaTelheiroGalpaoNoSplit(municipio: string | undefined | null): boolean {
  return isMunicipio(municipio, MUNICIPIOS_SPLIT_TELHEIRO_GALPAO);
}

/** Municípios que exigem ao menos um proprietário vinculado ao imobiliário antes de salvar. */
export const MUNICIPIOS_EXIGE_PROPRIETARIO = [
  "maracanau",
  "vitoriadaconquista",
  "riobranco",
] as const;

export function exigeProprietarioNoImobiliario(
  config?: ConfigCaracterizacao | null,
  municipio?: string | null
): boolean {
  if (typeof config?.exigirProprietarioNoImobiliario === "boolean") {
    return config.exigirProprietarioNoImobiliario;
  }

  return isMunicipio(municipio, MUNICIPIOS_EXIGE_PROPRIETARIO);
}
